<template><div></div></template>

<script setup lang="ts">
// this just acts as a wrapper of the hook so that it can be called from a Vue2 component
import { usePhotoUpload } from "@/modules/photos/usePhotoUpload";

const { upload } = usePhotoUpload();

defineExpose({ upload });
</script>
